<template>
    <div>
        <van-row>
            <van-col span="12">
                <div style="font-size: 13px; color: #596c83; background-color: white">受邀规模</div>
            </van-col>
            <van-col span="12">
                <div style="font-size: 13px; color: #596c83; background-color: white">资源数量</div>
            </van-col>
        </van-row>
        <div v-for="(param, i) in paramList" :key="i" style="margin-top: 15px">
            <div
                style="display: flex; flex-direction: row; align-content: center; justify-content: center; align-items: center">
                <div
                    v-if="!consumptionTypeKey || consumptionTypeKey == param.consumptionTypeKey"
                    style="width: 140px; height: 60px; font-size: 12px; text-align: center; border: #eee 1px solid; border-radius: 4px; display:flex; flex-direction: column; align-items: center; align-content: center; justify-items: center; justify-content: center"
                    :style="{'color':pickedJmb.indexOf(i)>=0 ? '#07affa' : '#28405e', 'border-color':pickedJmb.indexOf(i)>=0 ? '#07affa' : '#eee'}"
                    @click="toggleJmb(i)">
                    <div style="font-size: 15px">
                        {{param.consumptionTypeValue}}
                    </div>
                    <div style="margin-top: 5px;">
                                        <span>
                                            {{param.unitPrice/100}}元
                                        </span>
                        <span v-if="pickedJmb.indexOf(i)>=0"> * {{param.num}}个</span>
                    </div>
                </div>
                <div style="flex: 1"></div>
                <div v-if="pickedJmb.indexOf(i)>=0 ">
                    <van-stepper
                        v-model="param.num"
                        integer
                        @change="pickedJmbChange"
                        input-width="100px"
                        :min="1"
                        :max="10000"></van-stepper>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'va-call-sku',
        data() {
            return {
                pickedJmb: [],
                pickedJmbData: []
            };
        },
        props: {
            paramList: {
                type: Array,
                default: function () {
                    return [];
                }
            }
        },
        computed: {
            consumptionTypeKey() {
                return this.$route.query.consumptionTypeKey;
            }
        },
        methods: {
            hasType(key, type) {
                let consumptionTypeKey = this.$route.query.consumptionTypeKey;
                if (consumptionTypeKey && consumptionTypeKey !== key) {
                    return false;
                }
                if (this.paramList && this.paramList.filter(m => m.basicServiceCode == type).length) {
                    return true;
                }
                return false;
            },
            toggleJmb(option) {
                if (this.pickedJmb.indexOf(option) >= 0) {
                    this.pickedJmb.splice(this.pickedJmb.indexOf(option), 1);
                } else {
                    this.pickedJmb.push(option);
                }
                this.pickedJmbChange();
            },
            // 加盟包
            pickedJmbChange() {
                // this.pickedJmbData = [];
                setTimeout(() => {
                    let L = _.cloneDeep(this.paramList);
                    this.pickedJmbData = L.filter((item, index) => this.pickedJmb.indexOf(index) != -1);
                    this.payPriceChange();
                }, 200);
            },

            // 计算价格
            payPriceChange() {
                let price = 0;
                let A = this.pickedJmbData;
                let skuName = '';
                if (A.length) {
                    let priceMap = A.map(item => {
                        let p = item.defautValue * item.unitPrice * item.num / item.unitNum;
                        if (item.endDayNum > 0) {
                            p = (p / 365 * item.endDayNum);
                        }

                        if (skuName) {
                            skuName += '；';
                        }
                        skuName += item.consumptionTypeValue;
                        skuName += ':';
                        skuName += item.num + '个';
                        return p;
                    });
                    price = (Math.round(priceMap.reduce((prev, next) => prev + next)) / 100) || 0;
                } else {
                    price = 0;
                }
                this.$emit('callPriceChanged', this.pickedJmbData, price, skuName);
            }
        }
    };
</script>

<style scoped>
    .sku-item {
        font-size: 12px;
        color: #07affa;
        text-align: center;
        border: #07affa 1px solid;
        border-radius: 4px;
        line-height: 27px;
        margin-bottom: 15px
    }

    .sku-item-normal {
        color: #28405e;
        border-color: #eee;
    }

    .sku--item-checked {
        color: #07affa;
        border-color: #07affa;
    }

    .sku-title {
        font-size: 13px;
        color: #596c83;
        background-color: white;
        margin-top: 20px;
        margin-bottom: 15px
    }
</style>
